module.exports = __webpack_public_path__ + "static/media/4.dd247311.jpg";